// extracted by mini-css-extract-plugin
module.exports = {"tableContentsMenu":"TableContentsMenu_tableContentsMenu__2Hi2M","tab":"TableContentsMenu_tab__1X5_L"};